import React from 'react';
import { Link } from 'react-router-dom';

import Button from '../common/components/Button/Button';

function Page404({ showHomeButton }) {
  return (
    <div className="page404-wrapper">
      <div className="page404-message">
        <div className="page404-message-bg">404</div>
        <div className="page404-message-text">Oops... Looks like you are lost!</div>
      </div>
      {!showHomeButton && (
        <Link to="/">
          <Button variant="contained">Back Home</Button>
        </Link>
      )}
    </div>
  );
}

export default Page404;
